import React from "react";
import PropTypes from "prop-types";

import AutocompleteField from "../../field/AutocompleteField";

import { Grid, Divider } from "@mui/material";

import { useTranslation } from "react-i18next";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

import useEquipmentService from "../../../services/equipmentService";
import { useAsync } from "../../../hooks/useAsync";

import TransactionOutMultiForm from "../TransactionOutMultiForm/TransactionOutMultiForm";
import useUserService from "../../../services/userService";

import useOfferService from "../../../services/offerService";
import BaseBox from "../../base/BaseBox/baseBox";

const CreateTicketOfferReservationForm = (props) => {
  const { t } = useTranslation();

  const { getAllowedWarehouseByTransactionKind } = useUserService();

  const allowedWarehouses = useAsync(() => {
    return getAllowedWarehouseByTransactionKind({
      permission_kind: "trans_out",
    });
  }, []);

  const { getEquipmentSelectList } = useEquipmentService();
  const equipmentSelectList = useAsync(getEquipmentSelectList);

  const { getOffersFilteringData } = useOfferService();
  const offerFilteringData = useAsync(getOffersFilteringData);

  if (
    equipmentSelectList.loading ||
    allowedWarehouses.loading ||
    offerFilteringData.loading
  )
    return <LoaderWrapper showLoader />;

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      rowGap={1}
      columnSpacing={1}
      marginTop={1}
    >
      <Grid item xs={12}>
        <BaseBox padding={2}>
          <TransactionOutMultiForm
            formValue={props.formValue}
            setFormValue={props.setFormValue}
            onChange={props.onChange}
            onChangeAutocomplete={
              props.onChangeAutocompleteFieldWithObjectOptions
            }
            allowedWarehouses={allowedWarehouses}
            showTransactionWz={false}
            showTransactionOrder={false}
            showTransactionNote={false}
            unfillRequiredFields={props.unfillRequiredFields}
            showTransactionAmountError={true}
          />
        </BaseBox>
      </Grid>
      <Grid item xs={6}>
        <AutocompleteField
          name={"owner"}
          label={t("form.offer.owner")}
          value={props.formValue?.owner}
          options={
            offerFilteringData.value ? offerFilteringData.value.owner : []
          }
          isObjectOption={true}
          optionLabelKey={"owner_short_name"}
          onChange={props.onChangeAutocompleteFieldWithObjectOptions}
          disableClearable
          addNewValue={false}
          error={props.unfillRequiredFields.includes("owner")}
          helperText={
            props.unfillRequiredFields.includes("owner") && t("field_required")
          }
        />
      </Grid>
    </Grid>
  );
};

CreateTicketOfferReservationForm.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
  onChange: PropTypes.func,
  onChangeAutocompleteFieldWithObjectOptions: PropTypes.func,
  readOnly: PropTypes.bool,
  readOnlyFields: PropTypes.bool,
  selectLabel: PropTypes.string,
  unfillRequiredFields: PropTypes.array,
};

CreateTicketOfferReservationForm.defaultProps = {
  readOnly: false,
  readOnlyFields: [],
  unfillRequiredFields: [],
};

export default CreateTicketOfferReservationForm;
